import React, { useState } from "react";
import gsap from "gsap";
import styled from "styled-components";
import ProgressBar from "../ProgressBar";
import { devices } from "../../styles";

import Logo from "../../assets/mediuk-logo.png";
import PopupHomepage from "../PopupHomepage/PopupHomepage";

function Header({ children }) {
  return <HeaderWrapper>{children}</HeaderWrapper>;
}

export function WelcomeHeader() {
  return (
    <Header>
      <div
        style={{
          maxWidth: "756px",
          display: "flex",
          flex: 1,
        }}
      >
          <img className="logo" alt="medi uk logo welcome" src={Logo} style={{marginLeft:"auto"}}/>
      </div>
    </Header>
  );
}
export function IntroHeader({ index, length, reset, hideReset }) {
  const [showPopup, setShowPopup] = useState(false);
  
  const progress = [
    ...new Array(length)
      .fill(true, 0, index + 1)
      .fill(false, index + 1, length),
  ];

  const handleLogoClick = () => {
    setShowPopup(true);
  };

  const handleHidePopup = () => {
    setShowPopup(false);
    if (hideReset) hideReset();
  };

  const handleStartOver = () => {
    setShowPopup(false);
    if (reset) reset();
  };

  return (
    
    <Header>
      <PopupHomepage 
        isShowed={showPopup}
        onStartOver={handleStartOver} 
        onHideBanner={handleHidePopup} 
      />
      <div
        style={{
          maxWidth: "756px",
          display: "flex",
          flex: 1,
          alignItems: "center",
        }}
      >
      <ProgressBar progress={progress} />
        <img 
          className="logo" 
          alt="medi uk logo" 
          src={Logo} 
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </Header>
  );
}
export function QuestionnaireHeader({ index, length, reset, hideReset }) {
  const [showPopup, setShowPopup] = useState(false);
  
  const progress = [
    ...new Array(length)
      .fill(true, 0, index + 1)
      .fill(false, index + 1, length),
  ];

  const handleLogoClick = () => {
    setShowPopup(true);
  };

  const handleHidePopup = () => {
    setShowPopup(false);
    if (hideReset) hideReset();
  };

  const handleStartOver = () => {
    setShowPopup(false);
    if (reset) reset();
  };

  return (
    <Header>
      <PopupHomepage 
        isShowed={showPopup}
        onStartOver={handleStartOver} 
        onHideBanner={handleHidePopup} 
      />
      <div
        style={{
          maxWidth: "756px",
          display: "flex",
          flex: 1,
          alignItems: "center",
        }}
      >
        {/* <Reset onClick={() => animationOnReset()}>
          <img alt="reset arrow" src={ResetIcon} />
        </Reset> */}
        <ProgressBar isQuestionnaire={true} progress={progress} />
        
          <img 
            className="logo" 
            alt="medi uk logo" 
            src={Logo} 
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          />
        
      </div>
    </Header>
  );
}

const HeaderWrapper = styled.header`
  height: 80px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  z-index: 2;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-shadow: 0px 2px 6px 2px rgba(60, 64, 67, 0.15);
  filter: drop-shadow(0px 1px 2px rgba(60, 64, 67, 0.3));

  img.logo {
    display: flex;
    align-items: center;
    margin-left: 24px;
    height: 40px;
    width: 40px;
    float:right
  }

  @media ${devices.tablet} {
    height: 120px;
    padding: 40px 0;
    justify-content: center;
  }

  @media ${devices.desktop} {
    padding-top: 32px;
    padding-bottom: 32px;
    

    img.logo {
      margin-left: 32px;
      height: 55px;
      width: 55px;
    }
  }
`;

const Reset = styled.div`
  height: 48px;
  width: 48px;
  min-width: 48px;
  border-radius: 50%;
  border: 1px solid #d4ccbd;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 24px;

  img {
    height: 24px;
    width: 24px;
    margin: 0px;
  }

  &:hover {
    cursor: pointer;
    border-color: #f399c7;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @media ${devices.desktop} {
    width: 964px;
  }
`;
